/*
  Live redirect for editor-only market languages.
  Rules are passed on the script tag from snippets/eglo-editor-only-locale.liquid.
  Loaded without defer so the URL is replaced before the page paints.
  The theme editor does not include this script. designMode is a second guard.
  var is required here: Shopify's asset minifier targets ES5 and rejects const/let.
*/
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  var currentScript = document.currentScript;

  if (!currentScript) return;

  var rules;

  try {
    rules = JSON.parse(currentScript.getAttribute('data-rules') || '[]');
  } catch (error) {
    return;
  }

  var path = window.location.pathname || '/';
  var segments = path.split('/');
  var firstSegment = (segments[1] || '').toLowerCase();

  if (!firstSegment || !Array.isArray(rules)) return;

  var targetLocale = '';
  var index;

  for (index = 0; index < rules.length; index += 1) {
    var rule = rules[index];

    if (rule && rule.from === firstSegment) {
      targetLocale = String(rule.to || '').toLowerCase();
      break;
    }
  }

  if (!targetLocale || targetLocale === firstSegment) return;

  var remainder = path.slice(firstSegment.length + 1);
  var nextPath = '/' + targetLocale + remainder;
  var nextUrl = nextPath + window.location.search + window.location.hash;
  var currentUrl = path + window.location.search + window.location.hash;

  if (nextUrl === currentUrl) return;

  window.location.replace(nextUrl);
})();
